(() => {
  if (customElements.get('final-run-alternative')) return;
  const sizeKey = value => String(value || '').normalize('NFKC').replace(/[‘’]/g, "'").replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim().toLowerCase();
  customElements.define('final-run-alternative', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      if (!this.info) return;
      this.revision = 0;
      this.intro = this.querySelector('.fr-intro');
      this.choices = this.querySelector('.fr-choices');
      this.selection = this.querySelector('.fr-selection');
      this.offer = this.querySelector('.fr-offer');
      this.restock = this.querySelector('.fr-restock');
      this.or = this.querySelector('.fr-or');
      this.error = this.querySelector('.fr-error');
      this.form = this.querySelector('.fr-form');
      this.form.addEventListener('submit', event => this.addToCart(event));
      this.onOptions = event => {
        if (!event.target.closest('variant-selects')) return;
        // Clear a previous color immediately, before Shopify resolves the new size.
        ++this.revision;
        this.chosen = null;
        this.restock.hidden = true;
        this.restock.open = false;
        this.selection.hidden = true;
      this.offer.hidden = true;
      this.or.hidden = true;
        this.choices.replaceChildren();
        if (!this.hidden) this.intro.textContent = 'Checking your selected size…';
      };
      this.info.addEventListener('change', this.onOptions);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) === this.dataset.section) this.update(data.variant);
      });
      const initial = this.info.querySelector('variant-selects [data-selected-variant]');
      this.update(initial ? JSON.parse(initial.textContent) : null);
    }
    disconnectedCallback() {
      ++this.revision;
      this.unsubscribe?.();
      this.info?.removeEventListener('change', this.onOptions);
    }
    money(cents, trimZeros = false) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', minimumFractionDigits: trimZeros ? 0 : 2, maximumFractionDigits: 2, currency: window.Shopify?.currency?.active || this.dataset.currency || 'USD' }).format(cents / 100);
    }
    async update(orange) {
      const revision = ++this.revision;
      this.orange = orange;
      this.chosen = null;
      this.selection.hidden = true;
      this.offer.hidden = true;
      this.or.hidden = true;
      this.error.hidden = true;
      this.choices.replaceChildren();
      const unavailable = orange && !orange.available;
      this.hidden = !unavailable;
      this.info.classList.toggle('fr-unavailable', Boolean(unavailable));
      if (!unavailable) return;
      this.restock.hidden = false;
      this.querySelector('.fr-restock-size').textContent = `Orange · ${orange.option1}`;
      this.querySelector('.fr-restock-size-input').value = orange.option1;
      this.querySelector('.fr-restock-variant').value = orange.id;
      this.querySelector('.fr-restock-body').value = `Please notify me when orange FCSS Pro returns in ${orange.option1}. Orange variant ID: ${orange.id}.`;
      const restockForm = this.querySelector('.fr-restock-form');
      if (restockForm) {
        const returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set('variant', orange.id);
        returnUrl.hash = restockForm.id;
        let returnTo = restockForm.querySelector('[name=return_to]');
        if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; restockForm.append(returnTo); }
        returnTo.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
        if (window.location.hash === `#${restockForm.id}`) this.restock.open = true;
      }
      this.intro.textContent = 'Orange is sold out in this size. Checking available colors…';
      try {
        const response = await fetch(`${this.dataset.url}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('availability');
        const product = await response.json();
        if (revision !== this.revision || !this.isConnected) return;
        const sizePosition = product.options.findIndex(o => String(o.name || o).toLowerCase() === 'size');
        const colorPosition = product.options.findIndex(o => String(o.name || o).toLowerCase() === 'color');
        if (sizePosition < 0 || colorPosition < 0) throw new Error('options');
        const matches = product.variants.filter(v => v.available && sizeKey(v.options[sizePosition]) === sizeKey(orange.option1));
        this.matches = matches;
        this.choices.classList.toggle('fr-single', matches.length === 1);
        if (!matches.length) {
          this.intro.textContent = 'Neither orange nor Final Run has this exact size available right now. Choose another size only if it is your correct fit.';
          return;
        }
        const lead = document.createElement('strong');
        lead.textContent = 'Orange is sold out in your size.';
        const options = document.createElement('span');
        options.textContent = 'Choose a legacy color below, or get notified when orange is back.';
        this.intro.replaceChildren(lead, document.createTextNode(' '), options);
        this.showPrice(matches.reduce((lowest, v) => v.price < lowest.price ? v : lowest), new Set(matches.map(v => v.price)).size > 1);
        this.offer.hidden = false;
        this.or.hidden = false;
        for (const variant of matches) {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'fr-choice'; button.dataset.variantId = variant.id;
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', `${variant.options[colorPosition]}, ${orange.option1}, ${this.money(variant.price)}`);
          const photo = variant.featured_image?.src;
          if (photo) { const img = document.createElement('img'); img.src = photo; img.alt = `${variant.options[colorPosition]} Final Run inserts`; img.width = 150; img.height = 100; button.append(img); }
          button.addEventListener('click', () => this.select(variant, colorPosition));
          this.choices.append(button);
        }
        // Only one color requires no additional decision; multiple colors remain explicit choices.
        if (matches.length === 1) this.select(matches[0], colorPosition);
      } catch (_) {
        if (revision !== this.revision || !this.isConnected) return;
        this.intro.textContent = 'We couldn’t check available legacy colors. Please refresh to try again.';
      }
    }
    select(variant, colorPosition) {
      this.chosen = variant;
      for (const button of this.choices.children) button.setAttribute('aria-pressed', String(button.dataset.variantId === String(variant.id)));
      this.querySelector('.fr-selected').textContent = this.orange.option1;
      this.showPrice(variant);
      this.form.elements.id.value = variant.id;
      this.form.elements.quantity.value = '1';
      this.selection.hidden = false;
      this.error.hidden = true;
    }
    showPrice(variant, from = false) {
      const price = this.querySelector('.fr-price'); price.replaceChildren();
      const label = document.createElement('span'); label.className = 'fr-price-label'; label.textContent = 'Legacy color price';
      const amount = document.createElement('strong'); amount.textContent = `${from ? 'From ' : ''}${this.money(variant.price)}`;
      price.append(label, amount);
      if (!from && this.orange.price > variant.price) {
        const saving = document.createElement('span'); saving.className = 'fr-saving'; saving.textContent = `Save ${this.money(this.orange.price - variant.price, true)}`; price.append(saving);
      }
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.chosen || !this.matches?.some(v => v.id === this.chosen.id) || !this.form.reportValidity()) return;
      const quantity = Number(this.form.elements.quantity.value);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      this.busy = true;
      const button = this.querySelector('.fr-add'); button.disabled = true; button.textContent = 'Adding…';
      this.error.hidden = true;
      const chosen = this.chosen;
      try {
        const response = await fetch(`${this.dataset.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: chosen.id, quantity }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'This option could not be added. Please check availability again.');
        window.location.assign(`${this.dataset.root}cart`);
      } catch (error) {
        this.error.textContent = error.message || 'We couldn’t add this pair. Please try again.';
        this.error.hidden = false;
      } finally {
        this.busy = false; button.disabled = false; button.textContent = 'Add to Cart';
      }
    }
  });
})();
